export default "__VITE_ASSET__C5i3uV3Z__"